export default "__VITE_ASSET__e9013d41__"